/**
 * Affiche un élement.
 * @param {HTMLElement} element - Element à afficher
 * @return {undefined}
 */
export function show(element) {
  element?.classList.remove('hidden');
}

/**
 * Cache un élement.
 * @param {HTMLElement} element - Element à cacher
 * @return {undefined}
 */
export function hide(element) {
  element?.classList.add('hidden');
}

/**
 * Sélectionne tab parmi les tabs.
 * @param {HTMLElement} tab le tab à sélectionner
 * @return {undefined}
 */
export function select(tab) {
  if (!tab) {
    return;
  }

  tab.closest('.js-tabs__list').querySelectorAll('.js-tabs__button').forEach((currentTab) => {
    currentTab.setAttribute('aria-selected', 'false');
    currentTab.setAttribute('tabindex', '-1');
    hide(getPanel(currentTab));
  });
  tab.setAttribute('aria-selected', 'true');
  tab.removeAttribute('tabindex');
  const panel = getPanel(tab);
  show(panel);
  tab.dispatchEvent(new CustomEvent('tab:change'));
}

/**
 * Récupère le panel associé à un tab.
 * @param {HTMLElement} tab le tab
 * @return {HTMLElement} le panel associé au tab
 */
function getPanel(tab) {
  return document.getElementById(tab.getAttribute('aria-controls'));
}
